import React from 'react';

import GoogleCalendarLogo from 'Shared/components/Logos/GoogleCalendarLogo';
import Outlook365Logo from 'Shared/components/Logos/Outlook365Logo';
import Avatar from 'Shared/components/Avatar/Avatar';
import { AvatarType } from 'Shared/constants/types';

import './SuggestedTeammateFromCalendar.scss';
import { WpIcon } from 'Wpds/components/icon';

type Props = {
  recurringMeeting: {
    name: string;
    id: number;
    source: string;
  };
  person: {
    userId: number;
    email: string;
    fullName: string;
    avatar?: AvatarType;
  };
  suggestionType: string;
  onClick: Function;
};

function SuggestedTeammateFromCalendar({ recurringMeeting, person, suggestionType, onClick }: Props) {
  const handleContainerClick = () =>
    onClick({
      recurringMeetingId: suggestionType === 'one_on_one_meeting' ? recurringMeeting.id : null,
      userId: person.userId,
      email: person.email,
      fullName: person.fullName,
    });

  const foundFromText = {
    one_on_one_meeting: `Found from meeting: ${recurringMeeting?.name}`,
    group_meeting: `Found from meeting: ${recurringMeeting?.name}`,
    member: 'Already on PI Perform',
  }[suggestionType];

  const fromMeeting = suggestionType === 'one_on_one_meeting' || suggestionType === 'group_meeting';
  const isGoogleSource = recurringMeeting?.source === 'google';

  return (
    <div className="suggested-teammate-from-calendar d-flex p-2 cursor-pointer" onClick={handleContainerClick}>
      <div className="d-flex flex-column">
        {fromMeeting && (
          <div className="d-flex align-items-center">
            {isGoogleSource ? (
              <GoogleCalendarLogo width="16" className="mr-2" />
            ) : (
              <Outlook365Logo width="16" className="mr-2" />
            )}
            {person.email}
          </div>
        )}
        {!fromMeeting && (
          <div className="d-flex align-items-center">
            <Avatar avatar={person.avatar} height={24} classNames="mr-2" />
            {person.fullName || person.email}
          </div>
        )}
        <div className="suggested-teammate-from-calendar-meeting">{foundFromText}</div>
      </div>
      <div className="suggested-teammate-from-calendar-text-icon d-flex align-items-center ml-auto">
        <WpIcon name="plus-circle" />
      </div>
    </div>
  );
}

export default SuggestedTeammateFromCalendar;
